import moment from "moment";
import 'moment/locale/es';


export default function initMoment(language) {
    moment.locale(language);

    switch(language) {
        case 'es': {
            break;
        }
    }

    return moment;
}